/* ================================================== */
/* ISOTOPE → back filtered
/* ================================================== */

$(document).ready(function(){

	if (Modernizr.sessionstorage){
		if ($('body.homepage').length) {
			var filterValue = getQueryStringValue('filter');
			if (filterValue !== '') {
				sessionStorage.setItem('filteredCategory', filterValue);
			} else {
				sessionStorage.setItem('filteredCategory', 'all');
			}
		} else if ($('body:not(.homepage):not(.works)').length) {
			sessionStorage.removeItem('filteredCategory');
		}

		$('[data-filter] a').click(function(event) {
			event.preventDefault();
			var cat = $(this).parent().data('mode');
			sessionStorage.setItem('filteredCategory', cat);
		});

		if ($('body.works header nav ul.left a').length) {
			var previousCat = sessionStorage.getItem('filteredCategory');
			if (previousCat !== '') {
				$('[data-mode="' + previousCat + '"] a').addClass('on').attr('href', 'javascript:history.back()');
			}
		}
	}

});